import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/confirmarpedido',
    name: 'ConfirmarPedido',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ConfirmarPedido.vue')
  },
  {
    path: '/pedidoencaminhado',
    name: 'PedidoEncaminhado',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PedidoEncaminhado.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/index.vue'),

    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        name:"abrelista",
        path: 'lista',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/AbrirLista.vue'),
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        name:"listaprodutos",
        path: 'produtos',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/ListaProdutos.vue'),
      },
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        name:"editaprodutos",
        path: 'produtos/:id',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/EditaProdutos.vue'),
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        name:"pedidos",
        path: 'pedidos',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/PedidosLista.vue'),
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        name:"pedidosItem",
        path: 'pedidos/:listaid',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/Pedido.vue'),
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        name:"pedidos",
        path: 'pedidos/:listaid/:pedidoid',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/PedidoView.vue'),
      },
      {
        // UserPosts will be rendered inside User's <router-view>
        // when /user/:id/posts is matched
        name:"regiaoentrega",
        path: 'regioesentrega',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RegioesEntrega.vue'),
      }
    ]

  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
